export const _getStudentData = (state, action) => action.payload;
